/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        container: {
            position: 'relative',
            width: '75%'
        },
        favIcon: {
            background: 'none !important'
        },
        image: {
            ratio: 1
        },
        link: {
            display: 'block'
        },
        price: {},
        title: {
            marginBottom: {base: '8px'},
            padding: '0px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            webkitboxorient: 'vertical',
            display: '-webkit-box',
            webkitlineclamp: '2',
            height: {base: '40px', md: '45px'},
            color: 'textColor',
            lineHeight: {base: '20px', md: '24px'},
            fontSize: {base: '12px', sm: '14px', md: '16px'},
            textAlign: 'left',
            fontWeight: '500'
            /* autoprefixer: off */
        },
        backandPreOrder: {
            marginBottom: '8px',
            padding: '0px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            webkitboxorient: 'vertical',
            display: '-webkit-box',
            webkitlineclamp: '2',
            height: {base: '32px', sm: '37px'},
            lineHeight: {base: '16px', sm: '20px'},
            fontSize: {base: '12px', sm: '16px'},
            textAlign: 'left',
            color: '#2abdbb'
        },
        pdTitle: {
            marginBottom: '8px',
            padding: '0px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            webkitboxorient: 'vertical',
            display: '-webkit-box',
            webkitlineclamp: '2',
            height: {base: '40px', sm: '37px'},
            color: 'woodsmoke',
            lineHeight: '20px',
            textAlign: 'left'
            /* autoprefixer: off */
        },
        rating: {},
        variations: {},
        badgeGroup: {
            position: 'absolute',
            top: 2,
            left: 2
        },
        tileDetails: {
            textAlign: 'left'
        },
        twoColumnBox: {
            display: 'flex',
            alignItems: 'center'
        },
        atcMessage: {
            position: 'absolute',
            width: '100%',
            top: '100px',
            zIndex: 3
        }
    }),
    parts: [
        'container',
        'imageWrapper',
        'image',
        'price',
        'title',
        'rating',
        'variations',
        'atcButton',
        'showBadge',
        'tileDetails'
    ]
}
